import { connect } from 'react-redux';

import {
  getOfficesShortList,
  getPublicZoneList,
} from '../../Offices/officesActions';
import { getMasterTasks } from '../MasterTasks/masterTasksActions';
import MasterSubTasks from './MasterSubTasks';
import {
  addMasterSubTask,
  editMasterSubTask,
  getMasterSubTasks,
} from './masterSubTasksActions';

const mapStateToProps = state => ({
  masterSubTasksList: state.task.masterSubTasksList,
  isLoading: state.task.masterSubTasksLoading,
  totalTasksCount: state.task.masterSubTasksCount,
  pageSize: state.task.masterSubTasksPageSize,
  publicZoneList: state.office.publicZoneList,
  officesShortList: state.office.officesShortList,
  officesShortList2: state.office.officesShortList2,
  addTaskLoading: state.task.addMasterSubTaskLoading,
  // Add master tasks data
  masterTasksList: state.task.masterTasksList,
  masterTasksLoading: state.task.masterTasksLoading,
});

const mapDispatchToProps = dispatch => ({
  getMasterSubTasks: params => dispatch(getMasterSubTasks(params)),
  editMasterSubTask: params => dispatch(editMasterSubTask(params)),
  addMasterSubTask: (params, callback) =>
    dispatch(addMasterSubTask(params, callback)),
  getPublicZoneList: params => dispatch(getPublicZoneList(params)),
  getOfficesShortList: params => dispatch(getOfficesShortList(params)),
  // Add getMasterTasks
  getMasterTasks: params => dispatch(getMasterTasks(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MasterSubTasks);
